module.exports = __webpack_public_path__ + "img/emotion-style@2x.4835155.webp";